import { ContextAction } from '../types';
import type {
  VerifierAuthenticationAction,
  VerifierAuthenticationState
} from './types';

export const userInitial = {};

export const verifierAuthenticationReducer = (
  state: VerifierAuthenticationState | undefined,
  action: VerifierAuthenticationAction
): VerifierAuthenticationState | undefined => {
  switch (action.type) {
    case ContextAction.setVerifierAuthentication:
      return { ...state, ...action.payload } as VerifierAuthenticationState;
    case ContextAction.resetVerifierAuthentication:
      return userInitial;
    default:
      return state;
  }
};
